import type { IRequestShape, } from "@bracket/graphql/types";


export const getRequestShape = async ():Promise<typeof requests> => requests;


// NOTE: Requests implements the IRequestShape type but for developers we want the derived type.
// const requests: IRequestShape = {
export const requests = {
	query: {
		// Server version query
		"VERSION": {
			method: "POST",
			path: "version",
			arguments: {},
			optionalArguments: [],
			query: `query { version { name version } }`,
			response: {
				data: {
					version: {
						name: "string",
						version: "string",
					},
				},
			},
			headers: {},
		},

		// Add two numbers (test query)
		"ADD": {
			method: "POST",
			path: "add",
			arguments: {
				x: 0,
				y: 0,
			},
			optionalArguments: ["x", "y"],
			query: `query add($x: Int, $y: Int) { add(x: $x, y: $y) }`,
			response: {
				data: {
					add: 0,
				},
			},
			headers: {},
		},

		// Check in a wallet
		"CHECKIN": {
			method: "POST",
			path: "checkin",
			arguments: {
				wallet: "ADDRESS",
			},
			optionalArguments: [],
			query: `query checkin($wallet: String!) {
				checkin(wallet: $wallet) {
					address created referee referee_id staked safary_id claimr_id confirmed user_id notification_status salt claimr_rank claimr_points
				}
			}`,
			response: {
				data: {
					checkin: {
						address: "string",
						created: "string",
						referee: "string",
						referee_id: "string",
						staked: false,
						safary_id: "string",
						claimr_id: "string",
						confirmed: false,
						user_id: 0,
						notification_status: "string",
						salt: "string",
						claimr_rank: 0,
						claimr_points: 0,
					},
				},
			},
			headers: {},
		},

		// Get list of wallets with pagination
		"WALLETS": {
			method: "POST",
			path: "wallets",
			arguments: {
				take: 10,
				offset: 0,
			},
			optionalArguments: ["take", "offset"],
			query: `query wallets($take: Int, $offset: Int) {
				wallets(take: $take, offset: $offset) {
					address created staked confirmed user_id notification_status
				}
			}`,
			response: {
				data: {
					wallets: [{
						address: "string",
						created: "string",
						staked: false,
						confirmed: false,
						user_id: 0,
						notification_status: "string",
					}],
				},
			},
			headers: {},
		},

		// Get a single wallet by address
		"WALLET": {
			method: "POST",
			path: "wallet",
			arguments: {
				address: "ADDRESS",
			},
			optionalArguments: ["address"],
			query: `query wallet($address: String) {
				wallet(address: $address) {
					address created referee referee_id staked safary_id claimr_id confirmed user_id notification_status salt claimr_rank claimr_points
				}
			}`,
			response: {
				data: {
					wallet: {
						address: "string",
						created: "string",
						referee: "string",
						referee_id: "string",
						staked: false,
						safary_id: "string",
						claimr_id: "string",
						confirmed: false,
						user_id: 0,
						notification_status: "string",
						salt: "string",
						claimr_rank: 0,
						claimr_points: 0,
					},
				},
			},
			headers: {},
		},

		// Get user by wallet address
		"WALLET_USER": {
			method: "POST",
			path: "walletUser",
			arguments: {
				wallet: "ADDRESS",
			},
			optionalArguments: [],
			query: `query walletUser($wallet: String!) {
				walletUser(wallet: $wallet) {
					id email name nickname company kyc_status kyc_reason kyc_level kyc_next_level kyc_rejected_level kyc_data kyc_since kyb_status kyb_reason kyb_level kyb_next_level kyb_rejected_level kyb_data kyb_since
				}
			}`,
			response: {
				data: {
					walletUser: {
						id: 0,
						email: "string",
						name: "string",
						nickname: "string",
						company: "string",
						kyc_status: "string",
						kyc_reason: "string",
						kyc_level: 0,
						kyc_next_level: 0,
						kyc_rejected_level: 0,
						kyc_data: "string",
						kyc_since: 0,
						kyb_status: "string",
						kyb_reason: "string",
						kyb_level: 0,
						kyb_next_level: 0,
						kyb_rejected_level: 0,
						kyb_data: "string",
						kyb_since: 0,
					},
				},
			},
			headers: {},
		},

		// Get user by email
		"USER": {
			method: "POST",
			path: "user",
			arguments: {
				email: "EMAIL",
			},
			optionalArguments: [],
			query: `query user($email: String!) {
				user(email: $email) {
					id email name nickname company kyc_status kyc_reason kyc_level kyc_next_level kyc_rejected_level kyc_data kyc_since kyb_status kyb_reason kyb_level kyb_next_level kyb_rejected_level kyb_data kyb_since
				}
			}`,
			response: {
				data: {
					user: {
						id: 0,
						email: "string",
						name: "string",
						nickname: "string",
						company: "string",
						kyc_status: "string",
						kyc_reason: "string",
						kyc_level: 0,
						kyc_next_level: 0,
						kyc_rejected_level: 0,
						kyc_data: "string",
						kyc_since: 0,
						kyb_status: "string",
						kyb_reason: "string",
						kyb_level: 0,
						kyb_next_level: 0,
						kyb_rejected_level: 0,
						kyb_data: "string",
						kyb_since: 0,
					},
				},
			},
			headers: {},
		},

		// Get all vaults
		"VAULTS": {
			method: "POST",
			path: "vaults",
			arguments: {},
			optionalArguments: [],
			query: `query {
				vaults {
					address chainId block created status launch_date close_date closed name title manager_address header header_info yield_desc fees_desc fees_info nav_info withdrawal_type withdrawal_type_info term_type objective navkey vanity_nav epoch nav_launch deposit_min description symbol logo estimated_performance enforced_capabilities strategy manager_fee bracket_fee tvl_fee amount_available fee_method risk_level denominated_asset_id version expected_lock_hours epoch_duration_days epoch_offset_hours withdraw_delay_days deposit_type deposit_type_info nav_update_schedule nav_update_schedule_info live service_model nav_updater_address bracket_claim_address manager_claim_address vault_admin_address kyc_required kyc_active kyc_group_id kyc_tier kyc_since kyb_required kyb_active kyb_available kyb_min_tier kyb_since looping delayed morpho_url pennyworks_entity
				}
			}`,
			response: {
				data: {
					vaults: [{
						address: "string",
						chainId: 0,
						block: 0,
						created: "string",
						status: "string",
						launch_date: "string",
						close_date: "string",
						closed: false,
						name: "string",
						title: "string",
						manager_address: "string",
						header: "string",
						header_info: "string",
						yield_desc: "string",
						fees_desc: "string",
						fees_info: "string",
						nav_info: "string",
						withdrawal_type: "string",
						withdrawal_type_info: "string",
						term_type: "string",
						objective: "string",
						navkey: "string",
						vanity_nav: 0,
						epoch: 0,
						nav_launch: "string",
						deposit_min: "string",
						description: "string",
						symbol: "string",
						logo: "string",
						estimated_performance: 0,
						enforced_capabilities: "string",
						strategy: "string",
						manager_fee: "string",
						bracket_fee: "string",
						tvl_fee: "string",
						amount_available: 0,
						fee_method: "string",
						risk_level: 0,
						denominated_asset_id: "string",
						version: "string",
						expected_lock_hours: 0,
						epoch_duration_days: 0,
						epoch_offset_hours: 0,
						withdraw_delay_days: 0,
						deposit_type: "string",
						deposit_type_info: "string",
						nav_update_schedule: "string",
						nav_update_schedule_info: "string",
						live: 0,
						service_model: "string",
						nav_updater_address: "string",
						bracket_claim_address: "string",
						manager_claim_address: "string",
						vault_admin_address: "string",
						kyc_required: false,
						kyc_active: false,
						kyc_group_id: 0,
						kyc_tier: 0,
						kyc_since: 0,
						kyb_required: false,
						kyb_active: false,
						kyb_available: false,
						kyb_min_tier: 0,
						kyb_since: 0,
						looping: false,
						delayed: false,
						morpho_url: "string",
						pennyworks_entity: "string",
					}],
				},
			},
			headers: {},
		},

		// Get a single vault by symbol
		"VAULT": {
			method: "POST",
			path: "vault",
			arguments: {
				symbol: "SYMBOL",
			},
			optionalArguments: ["symbol"],
			query: `query vault($symbol: String) {
				vault(symbol: $symbol) {
					address chainId block created status launch_date close_date closed name title manager_address header header_info yield_desc fees_desc fees_info nav_info withdrawal_type withdrawal_type_info term_type objective navkey vanity_nav epoch nav_launch deposit_min description symbol logo estimated_performance enforced_capabilities strategy manager_fee bracket_fee tvl_fee amount_available fee_method risk_level denominated_asset_id version expected_lock_hours epoch_duration_days epoch_offset_hours withdraw_delay_days deposit_type deposit_type_info nav_update_schedule nav_update_schedule_info live service_model nav_updater_address bracket_claim_address manager_claim_address vault_admin_address kyc_required kyc_active kyc_group_id kyc_tier kyc_since kyb_required kyb_active kyb_available kyb_min_tier kyb_since looping delayed morpho_url pennyworks_entity
				}
			}`,
			response: {
				data: {
					vault: {
						address: "string",
						chainId: 0,
						block: 0,
						created: "string",
						status: "string",
						launch_date: "string",
						close_date: "string",
						closed: false,
						name: "string",
						title: "string",
						manager_address: "string",
						header: "string",
						header_info: "string",
						yield_desc: "string",
						fees_desc: "string",
						fees_info: "string",
						nav_info: "string",
						withdrawal_type: "string",
						withdrawal_type_info: "string",
						term_type: "string",
						objective: "string",
						navkey: "string",
						vanity_nav: 0,
						epoch: 0,
						nav_launch: "string",
						deposit_min: "string",
						description: "string",
						symbol: "string",
						logo: "string",
						estimated_performance: 0,
						enforced_capabilities: "string",
						strategy: "string",
						manager_fee: "string",
						bracket_fee: "string",
						tvl_fee: "string",
						amount_available: 0,
						fee_method: "string",
						risk_level: 0,
						denominated_asset_id: "string",
						version: "string",
						expected_lock_hours: 0,
						epoch_duration_days: 0,
						epoch_offset_hours: 0,
						withdraw_delay_days: 0,
						deposit_type: "string",
						deposit_type_info: "string",
						nav_update_schedule: "string",
						nav_update_schedule_info: "string",
						live: 0,
						service_model: "string",
						nav_updater_address: "string",
						bracket_claim_address: "string",
						manager_claim_address: "string",
						vault_admin_address: "string",
						kyc_required: false,
						kyc_active: false,
						kyc_group_id: 0,
						kyc_tier: 0,
						kyc_since: 0,
						kyb_required: false,
						kyb_active: false,
						kyb_available: false,
						kyb_min_tier: 0,
						kyb_since: 0,
						looping: false,
						delayed: false,
						morpho_url: "string",
						pennyworks_entity: "string",
					},
				},
			},
			headers: {},
		},

		// Get platform data
		"PLATFORM": {
			method: "POST",
			path: "platform",
			arguments: {},
			optionalArguments: [],
			query: `query {
				platform {
					pnl { brkt usd }
					current { brkt usd }
					invested { brkt usd }
					brkt { eth usd }
					tvl { brkt usd }
					balance { brkt usd }
					strategies { brkt usd }
					points shares
				}
			}`,
			response: {
				data: {
					platform: {
						pnl: { brkt: 0, usd: 0 },
						current: { brkt: 0, usd: 0 },
						invested: { brkt: 0, usd: 0 },
						brkt: { eth: 0, usd: 0 },
						tvl: { brkt: 0, usd: 0 },
						balance: { brkt: 0, usd: 0 },
						strategies: { brkt: 0, usd: 0 },
						points: 0,
						shares: 0,
					},
				},
			},
			headers: {},
		},

		// Get notifications
		"NOTIFICATIONS": {
			method: "POST",
			path: "notifications",
			arguments: {},
			optionalArguments: [],
			query: `query {
				notifications {
					id recipient vault_address created title body icon action_url action_label status
				}
			}`,
			response: {
				data: {
					notifications: [{
						id: "string",
						recipient: "string",
						vault_address: "string",
						created: "string",
						title: "string",
						body: "string",
						icon: "string",
						action_url: "string",
						action_label: "string",
						status: "string",
					}],
				},
			},
			headers: {},
		},

		// Get transaction log
		"TRANSACTION_LOG": {
			method: "POST",
			path: "transaction_log",
			arguments: {},
			optionalArguments: [],
			query: `query {
				transaction_log {
					amount { brkt usd }
					shares created type trxn_type sub_type nav scheduled_time claimed_time status epoch_available symbol
				}
			}`,
			response: {
				data: {
					transaction_log: [{
						amount: { brkt: 0, usd: 0 },
						shares: 0,
						created: "string",
						type: "string",
						trxn_type: "string",
						sub_type: "string",
						nav: 0,
						scheduled_time: "string",
						claimed_time: "string",
						status: "string",
						epoch_available: 0,
						symbol: "string",
					}],
				},
			},
			headers: {},
		},

		// Get claimr data
		"CLAIMR": {
			method: "POST",
			path: "claimr",
			arguments: {},
			optionalArguments: [],
			query: `query { claimr { points } }`,
			response: {
				data: {
					claimr: {
						points: 0,
					},
				},
			},
			headers: {},
		},

		// Get platform data result
		"PLATFORM_DATA": {
			method: "POST",
			path: "platform_data",
			arguments: {},
			optionalArguments: [],
			query: `query {
				platform_data {
					platform_tvl { brkt usd }
					claimr_points
					total_holdings { brkt usd }
					total_invested { brkt usd }
					total_current_value { brkt usd }
					brkt_1d { deposits withdrawals }
					brkt_3d { deposits withdrawals }
					brkt_7d { deposits withdrawals }
					brkt_14d { deposits withdrawals }
					brkt_21d { deposits withdrawals }
					brkt_28d { deposits withdrawals }
				}
			}`,
			response: {
				data: {
					platform_data: {
						platform_tvl: { brkt: 0, usd: 0 },
						claimr_points: 0,
						total_holdings: { brkt: 0, usd: 0 },
						total_invested: { brkt: 0, usd: 0 },
						total_current_value: { brkt: 0, usd: 0 },
						brkt_1d: { deposits: 0, withdrawals: 0 },
						brkt_3d: { deposits: 0, withdrawals: 0 },
						brkt_7d: { deposits: 0, withdrawals: 0 },
						brkt_14d: { deposits: 0, withdrawals: 0 },
						brkt_21d: { deposits: 0, withdrawals: 0 },
						brkt_28d: { deposits: 0, withdrawals: 0 },
					},
				},
			},
			headers: {},
		},

		// Get vaults data result
		"VAULTS_DATA": {
			method: "POST",
			path: "vaults_data",
			arguments: {},
			optionalArguments: [],
			query: `query { vaults_data { total_holdings { brkt usd } } }`,
			response: {
				data: {
					vaults_data: {
						total_holdings: { brkt: 0, usd: 0 },
					},
				},
			},
			headers: {},
		},

		// Get BRKT price history
		"BRKT_PRICE_HISTORY": {
			method: "POST",
			path: "brkt_price_history",
			arguments: {
				start: "DATE_STRING",
				end: "DATE_STRING",
			},
			optionalArguments: ["start", "end"],
			query: `query brkt_price_history($start: String, $end: String) {
				brkt_price_history(start: $start, end: $end) {
					date conv_rate eth_price brkt_eth_price brkt_supply total_value
				}
			}`,
			response: {
				data: {
					brkt_price_history: [{
						date: 0,
						conv_rate: "string",
						eth_price: 0,
						brkt_eth_price: 0,
						brkt_supply: 0,
						total_value: 0,
					}],
				},
			},
			headers: {},
		},

		// Get BRKT price period
		"BRKT_PRICE_PERIOD": {
			method: "POST",
			path: "brkt_price_period",
			arguments: {
				start: "DATE_STRING",
				end: "DATE_STRING",
			},
			optionalArguments: ["start", "end"],
			query: `query brkt_price_period($start: String, $end: String) {
				brkt_price_period(start: $start, end: $end) {
					date conv_rate eth_price brkt_eth_price brkt_supply total_value
				}
			}`,
			response: {
				data: {
					brkt_price_period: [{
						date: 0,
						conv_rate: "string",
						eth_price: 0,
						brkt_eth_price: 0,
						brkt_supply: 0,
						total_value: 0,
					}],
				},
			},
			headers: {},
		},

		// Get managed vault by symbol
		"MANAGED_VAULT": {
			method: "POST",
			path: "managed_vault",
			arguments: {
				symbol: "SYMBOL",
			},
			optionalArguments: [],
			query: `query managed_vault($symbol: String!) {
				managed_vault(symbol: $symbol) {
					address chainId block created status launch_date close_date closed name title manager_address header header_info yield_desc fees_desc fees_info nav_info withdrawal_type withdrawal_type_info term_type objective navkey vanity_nav epoch nav_launch deposit_min description symbol logo estimated_performance enforced_capabilities strategy manager_fee bracket_fee tvl_fee amount_available fee_method risk_level denominated_asset_id version expected_lock_hours epoch_duration_days epoch_offset_hours withdraw_delay_days deposit_type deposit_type_info nav_update_schedule nav_update_schedule_info live service_model nav_updater_address bracket_claim_address manager_claim_address vault_admin_address kyc_required kyc_active kyc_group_id kyc_tier kyc_since kyb_required kyb_active kyb_available kyb_min_tier kyb_since looping delayed morpho_url pennyworks_entity
				}
			}`,
			response: {
				data: {
					managed_vault: {
						address: "string",
						chainId: 0,
						block: 0,
						created: "string",
						status: "string",
						launch_date: "string",
						close_date: "string",
						closed: false,
						name: "string",
						title: "string",
						manager_address: "string",
						header: "string",
						header_info: "string",
						yield_desc: "string",
						fees_desc: "string",
						fees_info: "string",
						nav_info: "string",
						withdrawal_type: "string",
						withdrawal_type_info: "string",
						term_type: "string",
						objective: "string",
						navkey: "string",
						vanity_nav: 0,
						epoch: 0,
						nav_launch: "string",
						deposit_min: "string",
						description: "string",
						symbol: "string",
						logo: "string",
						estimated_performance: 0,
						enforced_capabilities: "string",
						strategy: "string",
						manager_fee: "string",
						bracket_fee: "string",
						tvl_fee: "string",
						amount_available: 0,
						fee_method: "string",
						risk_level: 0,
						denominated_asset_id: "string",
						version: "string",
						expected_lock_hours: 0,
						epoch_duration_days: 0,
						epoch_offset_hours: 0,
						withdraw_delay_days: 0,
						deposit_type: "string",
						deposit_type_info: "string",
						nav_update_schedule: "string",
						nav_update_schedule_info: "string",
						live: 0,
						service_model: "string",
						nav_updater_address: "string",
						bracket_claim_address: "string",
						manager_claim_address: "string",
						vault_admin_address: "string",
						kyc_required: false,
						kyc_active: false,
						kyc_group_id: 0,
						kyc_tier: 0,
						kyc_since: 0,
						kyb_required: false,
						kyb_active: false,
						kyb_available: false,
						kyb_min_tier: 0,
						kyb_since: 0,
						looping: false,
						delayed: false,
						morpho_url: "string",
						pennyworks_entity: "string",
					},
				},
			},
			headers: {},
		},

		// Get LRT points
		"LRT_POINTS": {
			method: "POST",
			path: "lrt_points",
			arguments: {
				symbol: "SYMBOL",
				block: 0,
				chainId: 0,
			},
			optionalArguments: ["symbol", "block", "chainId"],
			query: `query lrt_points($symbol: String, $block: Int, $chainId: Int) {
				lrt_points(symbol: $symbol, block: $block, chainId: $chainId) {
					success balance block
					adjBalances { address balance }
				}
			}`,
			response: {
				data: {
					lrt_points: {
						success: false,
						balance: "string",
						block: 0,
						adjBalances: [{
							address: "string",
							balance: "string",
						}],
					},
				},
			},
			headers: {},
		},

		// Get platform value
		"PLATFORM_VALUE": {
			method: "POST",
			path: "platform_value",
			arguments: {},
			optionalArguments: [],
			query: `query { platform_value { apy tvl { brkt usd } } }`,
			response: {
				data: {
					platform_value: {
						apy: 0,
						tvl: { brkt: 0, usd: 0 },
					},
				},
			},
			headers: {},
		},

		// Get vaults short detail
		"VAULTS_SHORT_DETAIL": {
			method: "POST",
			path: "vaults_short_detail",
			arguments: {},
			optionalArguments: [],
			query: `query {
				vaults_short_detail {
					symbol name logo manager
					asset { id symbol name decimals chainId address }
					apy_series { epoch apy }
					tvl { asset usd }
					morpho { apy curator }
				}
			}`,
			response: {
				data: {
					vaults_short_detail: [{
						symbol: "string",
						name: "string",
						logo: "string",
						manager: "string",
						asset: {
							id: "string",
							symbol: "string",
							name: "string",
							decimals: 0,
							chainId: 0,
							address: "string",
						},
						apy_series: [{
							epoch: 0,
							apy: 0,
						}],
						tvl: { asset: 0, usd: 0 },
						morpho: { apy: 0, curator: "string" },
					}],
				},
			},
			headers: {},
		},

		// Get WEI test values
		"WEI_TEST_VALUES": {
			method: "POST",
			path: "wei_test_values",
			arguments: {},
			optionalArguments: [],
			query: `query { wei_test_values { id wei_item_one } }`,
			response: {
				data: {
					wei_test_values: [{
						id: 0,
						wei_item_one: "string",
					}],
				},
			},
			headers: {},
		},

		// Pennyworks vault positions (existing query)
		"PENNYWORKS_VAULT_POSITIONS": {
			method: "POST",
			path: "vault.pennyworks_positions",
			arguments: {
				vault: "SYMBOL",
				latest: true,
			},
			optionalArguments: [],
			query: `query vault($vault: String!, $latest: Boolean) {
				vault(symbol: $vault) {
					pennyworks_positions(latest: $latest) { 
						salt chain symbol protocol end_value_usd account_type position_health_factor
						position_is_at_risk period_start period_end position_id epoch
					}
				}
			}`,
			response: {
				data: {
					vault: {
						pennyworks_positions: [{
							salt: "string",
							chain: "string",
							symbol: "string",
							protocol: "string",
							end_value_usd: "string",
							account_type: "string",
							position_health_factor: "string",
							position_is_at_risk: "string",
							period_start: "string",
							period_end: "string",
						}],
					},
				},
			},
			headers: {},
		},
	},
	mutation: {
		// Update user profile
		"UPDATE_PROFILE": {
			method: "POST",
			path: "update_profile",
			arguments: {
				name: "NAME",
				nickname: "NICKNAME",
				email: "EMAIL",
			},
			optionalArguments: ["name", "nickname", "email"],
			query: `mutation update_profile($name: String, $nickname: String, $email: String) {
				update_profile(name: $name, nickname: $nickname, email: $email) {
					success
				}
			}`,
			response: {
				data: {
					update_profile: {
						success: false,
					},
				},
			},
			headers: {},
		},

		// Record UI error
		"RECORD_UI_ERROR": {
			method: "POST",
			path: "record_ui_error",
			arguments: {
				system: "SYSTEM",
				code: "CODE",
				address: "ADDRESS",
				message: "MESSAGE",
				stack: "STACK",
				data: "DATA",
			},
			optionalArguments: ["system", "code", "address", "message", "stack", "data"],
			query: `mutation record_ui_error($system: String, $code: String, $address: String, $message: String, $stack: String, $data: String) {
				record_ui_error(system: $system, code: $code, address: $address, message: $message, stack: $stack, data: $data) {
					success
				}
			}`,
			response: {
				data: {
					record_ui_error: {
						success: false,
					},
				},
			},
			headers: {},
		},

		// Update notifications status
		"NOTIFICATIONS_STATUS": {
			method: "POST",
			path: "notifications_status",
			arguments: {
				status: "STATUS",
			},
			optionalArguments: ["status"],
			query: `mutation notifications_status($status: String) {
				notifications_status(status: $status)
			}`,
			response: {
				data: {
					notifications_status: false,
				},
			},
			headers: {},
		},

		// Apply claim
		"APPLY_CLAIM": {
			method: "POST",
			path: "apply_claim",
			arguments: {
				email: "EMAIL",
				amount: "AMOUNT",
			},
			optionalArguments: ["email", "amount"],
			query: `mutation apply_claim($email: String, $amount: String) {
				apply_claim(email: $email, amount: $amount)
			}`,
			response: {
				data: {
					apply_claim: false,
				},
			},
			headers: {},
		},

		// Agree to terms
		"AGREE": {
			method: "POST",
			path: "agree",
			arguments: {
				agreement: "AGREEMENT_TYPE",
				vault: "VAULT",
			},
			optionalArguments: ["vault"],
			query: `mutation agree($agreement: UserAgreementType!, $vault: String) {
				agree(agreement: $agreement, vault: $vault)
			}`,
			response: {
				data: {
					agree: false,
				},
			},
			headers: {},
		},

		// Add WEI value (test mutation)
		"ADD_WEI_VALUE": {
			method: "POST",
			path: "add_wei_value",
			arguments: {
				value: "WEI_VALUE",
			},
			optionalArguments: [],
			query: `mutation add_wei_value($value: WEI!) {
				add_wei_value(value: $value) {
					id wei_item_one
				}
			}`,
			response: {
				data: {
					add_wei_value: {
						id: 0,
						wei_item_one: "string",
					},
				},
			},
			headers: {},
		},
	},
} as const;

export declare type Requests = typeof requests;
